import { useEffect, useRef } from "react";
import blogHeroBg from "@/assets/heroes/blog-hero.jpg";

interface PageHeroProps {
  title: string;
  subtitle?: string;
  badge?: string;
  backgroundImage?: string;
}

export const PageHero = ({ title, subtitle, badge, backgroundImage }: PageHeroProps) => {
  const bgImage = backgroundImage || blogHeroBg;
  const bgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (bgRef.current) {
        bgRef.current.style.transform = `translateY(${window.scrollY * 0.4}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="relative overflow-hidden">
      <section className="relative pt-52 md:pt-48 lg:pt-52 pb-24" aria-labelledby="page-hero-title">
        <div
          ref={bgRef}
          className="absolute inset-0 -top-20 -bottom-20 bg-cover bg-center will-change-transform"
          style={{ backgroundImage: `url(${bgImage})` }}
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-black/65" aria-hidden="true" />
        <div className="relative z-10 container mx-auto px-4">
          <div className="max-w-3xl">
            {badge && (
              <span className="inline-block px-4 py-1.5 text-sm font-medium rounded-full bg-white/15 text-white/90 backdrop-blur-sm border border-white/20 mb-4">
                {badge}
              </span>
            )}
            <h1 id="page-hero-title" className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4">
              {title}
            </h1>
            {subtitle && (
              <p className="text-lg md:text-xl text-white/80">
                {subtitle}
              </p>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};
